import React from "react";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  getServiceCenterBillingApi,
  getServiceCenterBillingExportApi,
} from "../../services/ServiceApi";
import { Spinner } from "react-bootstrap";
import { CancelRequest } from "../../services/AxiosInstance";
import Pagination from "../Constant/Pagination";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { FaDownload, FaInfo } from "react-icons/fa";
import { CustomTooltip } from "../../components/CustomTooltip";
import { dateRangeOptions, paymentMethodBadge } from "../../utilities";
import { paymentStatusBadge } from "../../utilities";
import { subDays, startOfMonth, endOfMonth, subMonths } from "date-fns";
import { format } from "date-fns";
import GlobalSearchableDropdown from "../Constant/SearchableDropdown";
import DatePicker from "react-datepicker";
import { BiSolidFileExport } from "react-icons/bi";
import { toast } from "react-toastify";
const ServiceCenterBillHistory = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState(dateRangeOptions[0]);
  const [exportLoading, setExportLoading] = useState(false);
  const [param, setParam] = useState({
    page: "1",
    page_size: "10",
    query: "",
    start_date: format(new Date(), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
  });

  const getData = () => {
    setLoading(true);
    getServiceCenterBillingApi(id, param)
      .then((res) => {
        setError("");
        setData(res?.data?.results || []);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getData();
  }, [param]);
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };
  const handleDateRangeChange = (option) => {
    setSelectedDate(option);
    if (!option) {
      setParam({
        ...param,
        start_date: "",
        end_date: "",
        page: "1",
      });
      return;
    }
    let startDate,
      endDate = new Date();
    switch (option.value) {
      case "today":
        startDate = new Date();
        endDate = new Date();
        break;
      case "yesterday":
        startDate = subDays(new Date(), 1);
        endDate = startDate;
        break;
      case "7_days":
        startDate = subDays(new Date(), 7);
        break;
      case "15_days":
        startDate = subDays(new Date(), 15);
        break;
      case "30_days":
        startDate = subDays(new Date(), 30);
        break;
      case "last_month":
        startDate = startOfMonth(subMonths(new Date(), 1));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "3_months":
        startDate = startOfMonth(subMonths(new Date(), 3));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "custom":
        setShowDatePicker(true);
        return;
      default:
        return;
    }
    setShowDatePicker(false);
    setParam({
      ...param,
      start_date: format(startDate, "yyyy-MM-dd"),
      end_date: format(endDate, "yyyy-MM-dd"),
      page: "1",
    });
  };

  const handleExport = () => {
    setExportLoading(true);
    getServiceCenterBillingExportApi(id,{ ...param, export: true })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Service-center-bills.xlsx";

        // Append to DOM to make it more consistent
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setExportLoading(false);
      });
  };
  return (
    <div>
      <div className="p-2 d-flex justify-content-between flex-wrap gap-2">
        <div className="d-flex gap-1 flex-fill flex-md-grow-0">
          <div className="flex-fill">
            <DebounceSmallSearchInput handleSearchChange={handleSearchChange} />
          </div>
        </div>
        <div className="d-flex gap-1 flex-wrap">
          {showDatePicker && (
            <div className="">
              <DatePicker
                selectsRange
                startDate={
                  param?.start_date ? new Date(param.start_date) : null
                }
                endDate={param?.end_date ? new Date(param.end_date) : null}
                onChange={(update) => {
                  const [start, end] = update;
                  setParam((prev) => ({
                    ...prev,
                    start_date: start ? format(start, "yyyy-MM-dd") : "",
                    end_date: end ? format(end, "yyyy-MM-dd") : "",
                    page: 1,
                  }));
                }}
                isClearable
                placeholderText="Select date range"
                className="form-control"
                style={{
                  fontSize: "0.5rem",
                }}
              />
            </div>
          )}
          <div className="">
            <GlobalSearchableDropdown
              options={dateRangeOptions}
              selected={selectedDate}
              onSelect={(item) => handleDateRangeChange(item)}
              placeholder="Period"
            />
          </div>
          <CustomTooltip title="Export">
            <button
              className="btn btn-success"
              style={{ padding: "0.45rem 0.6rem" }}
              onClick={handleExport}
              disabled={exportLoading||data?.length==0}
            >
              {exportLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <FaDownload size="16" />
              )}
            </button>
          </CustomTooltip>
        </div>
      </div>
      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" />
        </div>
      ) : error ? (
        <div className="text-center my-4 text-danger">{error}</div>
      ) : data && data?.length > 0 ? (
        <div className="table-responsive">
          <table className="table fs-6 mb-0 align-middle">
            <thead className="table-light custom-thead">
              <tr>
                <th>Invoice</th>
                <th>Vehicle</th>
                <th>Total</th>
                <th>Discount</th>
                <th>Tips</th>
                <th>Payment Status</th>
                <th>Payment Method</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, index) => (
                <tr key={item.id}>
                  <td>{item?.invoice_id || "-"}</td>

                  <td>
                    <div className="d-flex gap-1 align-items-center">
                      <span>{item?.vehicle?.vehicle_number || "-"}</span>
                      <CustomTooltip
                        title={
                          <div>
                            <div>
                              <strong>Vehicle Type:</strong>{" "}
                              {item?.vehicle?.vehicle_type || "-"}
                            </div>
                            <div>
                              <strong>Model:</strong>{" "}
                              {item?.vehicle?.vehicle_model?.name || "-"}
                            </div>
                            <div>
                              <strong>Customer Name:</strong>{" "}
                              {item?.vehicle?.customer_name || "-"}
                            </div>
                            <div>
                              <strong>Customer Contact:</strong>{" "}
                              {item?.vehicle?.customer_contact || "-"}
                            </div>
                            <div>
                              <strong>Total Services:</strong>{" "}
                              {item?.vehicle?.total_services_completed ?? "-"}
                            </div>
                          </div>
                        }
                        placement="right"
                      >
                        <span
                          className="rounded-1 ms-1 btn btn-sm btn-outline-light"
                          style={{
                            cursor: "pointer",
                            padding: "0.2rem 0.2rem",
                          }}
                        >
                          <FaInfo size={9} className="text-dark" />
                        </span>
                      </CustomTooltip>
                    </div>
                  </td>
                  <td>{item?.total || "0"}</td>
                  <td>{item?.discount || "0"}</td>
                  <td>{item?.tips || "0"}</td>
                  <td>
                    {item?.payment_status
                      ? paymentStatusBadge(item?.payment_status)
                      : "-"}
                  </td>
                  <td>
                    {item?.payment_method
                      ? paymentMethodBadge(item?.payment_method)
                      : "-"}
                  </td>
                  <td>
                    {item?.created_at
                      ? format(item?.created_at, "dd MMM yyy")
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center my-4">No data found</div>
      )}
      {!loading && data?.length > 0 && (
        <div className="p-1">
          <Pagination
            currentPage={param.page}
            recordsPage={param.page_size}
            dataLength={total}
            handlePagination={handlePageChange}
          />
        </div>
      )}
    </div>
  );
};

export default ServiceCenterBillHistory;
